import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  Platform,
  TouchableOpacity,
  Image,
  Modal,
} from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { getAllKidsCreator } from '../slices/authSlice';
import { toast } from 'react-toastify';
import { useNavigation } from '@react-navigation/native';

// Internal CSS for react-toastify
// const toastifyCss = `
// .Toastify__toast-container {
//   width: 320px;
//   z-index: 9999;
// }
// .Toastify__toast {
//   font-family: ${Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans'};
//   border-radius: 8px;
// }
// .Toastify__progress-bar {
//   background: #8DC63F;
// }`;

const AddKidsModal = ({ visible, onClose, onSave, tickets }) => {
  const dispatch = useDispatch();
  const navigate = useNavigation();
  const getAllkids = useSelector(state => state.auth.getAllkids);
  const kids = getAllkids?.Data?.kids || [];
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [selectedKids, setSelectedKids] = useState([]);

  useEffect(() => {
    dispatch(getAllKidsCreator());
  }, [dispatch]);

  const handleTicketSelect = (ticket) => {
    setSelectedTicket(ticket);
    setSelectedKids([]); // Reset selected kids when changing ticket
  };

  const handleKidToggle = (kid) => {
    if (!selectedTicket) {
      toast.error('Please select a ticket first', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    if (selectedKids.some(selectedKid => selectedKid.id === kid.id)) {
      setSelectedKids(prev => prev.filter(k => k.id !== kid.id));
    } else {
      if (selectedKids.length >= selectedTicket.no_of_kids) {
        toast.error(`You can only select ${selectedTicket.no_of_kids} kid(s) for this ticket`, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }
      setSelectedKids(prev => [...prev, kid]);
    }
  };

  const handleSave = () => {
    if (!selectedTicket) {
      toast.error('Please select a ticket first', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    if (selectedKids.length === 0) {
      toast.error('Please select at least one kid', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    if (selectedKids.length !== selectedTicket.no_of_kids) {
      toast.error(`Please select exactly ${selectedTicket.no_of_kids} kid(s) for this ticket`, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    onSave(selectedTicket, selectedKids);
    // Reset selections after saving
    setSelectedTicket(null);
    setSelectedKids([]);
  };

  const handleClose = () => {
    // Reset selections when closing
    setSelectedTicket(null);
    setSelectedKids([]);
    onClose();
  };

  const handleAddNewKid = () => {
    console.log('Add New Kid button clicked');
    try {
      // Close the modal first
      handleClose();
      // Then navigate to AddNewKidScreen using web navigation
      navigate('add-new-kid');
      console.log('Navigation attempted');
    } catch (error) {
      console.error('Navigation error:', error);
    }
  };

  return (
    <>
      {/* <style>{toastifyCss}</style> */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={visible}
        onRequestClose={handleClose}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalView}>
            <View style={styles.modalHeader}>
              <TouchableOpacity
                style={styles.closeButton}
                onPress={handleClose}
              >
                <Text style={styles.closeButtonText}>X</Text>
              </TouchableOpacity>
            </View>

            <View style={styles.kidsListContainer}>
              <ScrollView style={styles.kidsList}>
                {kids.map((kid) => (
                  <TouchableOpacity
                    key={kid.id}
                    style={styles.kidRow}
                    onPress={() => handleKidToggle(kid)}
                  >
                    <View style={styles.kidInfoContainer}>
                      <Image
                        source={kid.profilePic ? { uri: kid.profilePic } : require('../assets/AddKidPic.png')}
                        style={styles.kidImage}
                      />
                      <View>
                        <Text style={styles.kidName}>{kid.name}</Text>
                        <Text style={styles.kidDetails}>{`${kid.age} years, ${kid.gender === 'BOY' ? 'Boy' : 'Girl'}`}</Text>
                      </View>
                    </View>
                    {selectedKids.some(selectedKid => selectedKid.id === kid.id) && (
                      <View style={styles.selectedIndicator}>
                        <Text style={styles.tickMark}>✓</Text>
                      </View>
                    )}
                  </TouchableOpacity>
                ))}
              </ScrollView>
            </View>

            <TouchableOpacity
              style={styles.addNewKidButton}
              onPress={handleAddNewKid}
              activeOpacity={0.7}
            >
              <Text style={styles.addNewKidText}>Add New Kid</Text>
            </TouchableOpacity>

            <View style={styles.packagesContainer}>
              <ScrollView style={styles.packagesList}>
                {tickets && tickets.length > 0 ? (
                  tickets.map((ticket, index) => (
                    <TouchableOpacity
                      key={index}
                      style={[
                        styles.packageRow,
                        selectedTicket?.ticketId === ticket.ticketId && styles.selectedPackageRow
                      ]}
                      onPress={() => handleTicketSelect(ticket)}
                    >
                      <Text style={styles.packageTitle}>{`${ticket.no_of_kids}-Kids, ${ticket.dayType}`}</Text>
                      <Text style={styles.packagePrice}>{`$${ticket.price}`}</Text>
                    </TouchableOpacity>
                  ))
                ) : (
                  <Text style={styles.noTicketsText}>No tickets available</Text>
                )}
              </ScrollView>
            </View>

            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={styles.saveButton}
                onPress={handleSave}
              >
                <Text style={styles.saveButtonText}>Save</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    // backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 20,
    width: '90%',
    height: '80%',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  closeButton: {
    padding: 5,
  },
  closeButtonText: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  kidsListContainer: {
    maxHeight: '30%',
    marginBottom: 20,
  },
  kidsList: {
    height: '100%',
  },
  kidRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5E5',
  },
  kidInfoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  kidImage: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 15,
  },
  kidName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#000000',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansBold' : 'Facebook Sans',
  },
  kidDetails: {
    fontSize: 14,
    color: '#666666',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
  },
  selectedIndicator: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#8DC63F',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tickMark: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
  addNewKidButton: {
    backgroundColor: '#8DC63F',
    padding: 15,
    borderRadius: 10,
    minWidth: '30%',
    alignSelf: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  addNewKidText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansBold' : 'Facebook Sans',
  },
  packagesContainer: {
    maxHeight: '30%',
    marginBottom: 20,
  },
  packagesList: {
    height: '100%',
  },
  selectedPackageRow: {
    backgroundColor: '#E5F5D5',
    borderColor: '#8DC63F',
    borderWidth: 1,
  },
  packageRow: {
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5E5',
    paddingBottom: 10,
    padding: 10,
    borderRadius: 5,
  },
  packageTitle: {
    fontSize: 18,
    color: '#000000',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansBold' : 'Facebook Sans',
  },
  packagePrice: {
    fontSize: 16,
    color: '#666666',
    marginTop: 5,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
  },
  buttonContainer: {
    alignItems: 'center',
  },
  saveButton: {
    backgroundColor: '#8DC63F',
    padding: 15,
    borderRadius: 10,
    minWidth: '30%',
    alignItems: 'center',
  },
  saveButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: Platform.OS === 'android' ? 'FacebookSansBold' : 'Facebook Sans',
  },
  noTicketsText: {
    textAlign: 'center',
    color: '#666666',
    fontSize: 16,
    marginTop: 20,
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
  },
});

export default AddKidsModal; 